'use client';

import { cn } from '@/lib/utils';

interface ProviderLogoPlaceholderProps {
  companyName?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const sizeClasses = {
  sm: 'w-8 h-8',
  md: 'w-12 h-12',
  lg: 'w-16 h-16',
  xl: 'w-24 h-24',
};

const textSizeClasses = {
  sm: 'text-[6px]',
  md: 'text-[8px]',
  lg: 'text-[10px]',
  xl: 'text-sm',
};

export function ProviderLogoPlaceholder({
  companyName,
  size = 'md',
  className,
}: ProviderLogoPlaceholderProps) {
  return (
    <div
      className={cn(
        'flex items-center justify-center rounded-lg bg-gray-100 border border-gray-200 border-dashed',
        sizeClasses[size],
        className
      )}
      title={companyName || 'No logo'}
    >
      <span
        className={cn(
          'font-medium text-gray-400 tracking-wider select-none',
          textSizeClasses[size]
        )}
      >
        LOGO
      </span>
    </div>
  );
}
